import { ReactElement, useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import CreditLimitIncrease from '@account-services-mfe/credit-limit-increase'
import getMFEConfig from 'helpers/getMFEConfig'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'
import { creditLimitIncreaseContainerId } from 'const/modalContainerId'
import i18n from 'strings/i18n'

const CreditLimitIncreaseModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)

  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleEscapeAndModalHeader = () => {
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
    handleCloseModal()
  }

  return (
    <SlideInModalPortal
      id={`cli-slide-in-modal${selectedAccount}`}
      aria-label="credit limit increase"
      containerId={creditLimitIncreaseContainerId(selectedAccount)}
      escapeModalHandler={handleEscapeAndModalHeader}
      isOpen={modalId === 'CreditLimitIncrease'}
      modalTriggerId={modalTriggerId}
      header={
        <ModalHeader
          closeModal={handleEscapeAndModalHeader}
          content={i18n({ modal: 'creditLimitIncreaseTitle' }) as string}
          data-test="credit-limit-increase-modal-header"
          dataReason="x button"
          dataType="credit limit increase"
          headerRef={headerRef}
        />
      }
    >
      <CreditLimitIncrease
        config={mfeConfig}
        selectedAccountId={selectedAccount}
        handleClose={handleCloseModal}
        features={{
          brandRefreshPhase: getBrandRefreshPhase()
        }}
      />
    </SlideInModalPortal>
  )
}

export default CreditLimitIncreaseModal
